module.exports = __webpack_public_path__ + "static/media/download.8d878c8b.png";